import jsPDF from "jspdf";
import autoTable, { UserOptions } from "jspdf-autotable";

export const jspdfAutotableHelper = (
    autoTableContent: UserOptions[],
    filenName: string
) => {
    const doc = new jsPDF();

    autoTableContent.forEach(content => {
        autoTable(doc, content);
    });

    return doc.save(filenName);
};
